import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../env";

const legacyUrl = env.REACT_APP_LEGACY_URL;
export const convertToInstantPay = createAsyncThunk(
  "convertToInstantPay",
  async (values) => {
    const { txn_id } = values;
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
      body: JSON.stringify({
        txn_id: txn_id,
      }),
    };
    return await fetch(
      `${legacyUrl}/transactions/vendor/refill`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => (() => {})());
  }
);

const toInstantPay = createSlice({
  name: "toInstantPay",
  initialState: {
    isLoading: null,
    response: null,
    isError: false,
  },
  extraReducers: (builder) => {
    //vendor
    builder.addCase(convertToInstantPay.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(convertToInstantPay.fulfilled, (state, action) => {
      state.isLoading = false;
      state.response = action.payload;
    });
    builder.addCase(convertToInstantPay.rejected, (state, action) => {
      (() => {})();
      state.isError = true;
    });
  },
});

export default toInstantPay.reducer;
